<template>
  <div>
    <!-- Color Card -->
    <template v-if="cardContent.cardType === 'color'">
      <div
        :style="`background-color: ${cardContent.cardBackgroundColor.rgbaString}`"
        :class="`col-item card card-${cardContent.cardType} card-text-${cardContent.cardTextAlign}`"
      >
        <div
          :class="`card-content card-content-position-${cardContent.cardVerticalTextAlign}`"
          class="card-content-body"
        >
          <div
            :style="`color: ${cardContent.cardTextColor.rgbaString}`"
            class="title"
          >
            <h3>{{ cardContent.cardTitle }}</h3>
          </div>
          <div
            v-if="cardContent.cardDescription"
            :style="`color: ${cardContent.cardTextColor.rgbaString}`"
            class="description"
          >
            {{ cardContent.cardDescription }}
          </div>
          <template
            v-if="cardContent.cardButtonPrimaryUrl && cardContent.cardButtonPrimaryText || cardContent.cardButtonSecondaryUrl && cardContent.cardButtonSecondaryText"
          >
            <div class="card-actions">
              <template v-if="cardContent.cardButtonPrimaryUrl && cardContent.cardButtonPrimaryText">
                <generic-link
                  :target="primaryButtonTarget"
                  :href="cardContent.cardButtonPrimaryUrl"
                  class="btn btn-primary-cta"
                >
                  <span>{{ cardContent.cardButtonPrimaryText }}</span>
                </generic-link>
              </template>
              <template v-if="cardContent.cardButtonSecondaryUrl && cardContent.cardButtonSecondaryText">
                <generic-link
                  :target="secondaryButtonTarget"
                  :href="cardContent.cardButtonSecondaryUrl"
                  class="btn btn-secondary-cta"
                >
                  <span>{{ cardContent.cardButtonSecondaryText }}</span>
                </generic-link>
              </template>
            </div>
          </template>
          <template v-else-if="cardContent.cardButtonPrimaryUrl">
            <generic-link
              :target="primaryButtonTarget"
              :href="cardContent.cardButtonPrimaryUrl"
              class="card-overlay-link"
            />
          </template>
        </div>
      </div>
    </template>

    <!-- Photo Card -->
    <template v-if="cardContent.cardType === 'photo'">
      <div
        :class="`col-item card card-${cardContent.cardType} effect-image-scale card-text-${cardContent.cardTextAlign}`"
      >

        <div class="card-image">
          <!--<div-->
            <!--:style="`background-size: cover; background-image: url('${backgroundImageUrl}')`"-->
            <!--class="image-background"-->
          <!--/>-->
          <AImage
            :img="cardContent.fileStore"
            :title="cardContent.cardTitle"
            :alt="cardContent.cardTitle"
            :preset="`grid-image-${gridSize}`"
            responsive
          />
        </div>
        <div
          :style="`opacity:${cardContent.cardBackgroundTinting/100}`"
          class="image-overlay"
        />
        <div
          :class="`card-content card-content-position-${cardContent.cardVerticalTextAlign}`"
          class="card-content-body"
        >
          <div class="title">
            <h3>{{ cardContent.cardTitle }}</h3>
          </div>
          <div class="description">
            {{ cardContent.cardDescription }}
          </div>
          <template
            v-if="cardContent.cardButtonPrimaryUrl && cardContent.cardButtonPrimaryText || cardContent.cardButtonSecondaryUrl && cardContent.cardButtonSecondaryText"
          >
            <div class="card-actions">
              <template v-if="cardContent.cardButtonPrimaryUrl && cardContent.cardButtonPrimaryText">
                <generic-link
                  :target="primaryButtonTarget"
                  :href="cardContent.cardButtonPrimaryUrl"
                  class="btn btn-primary-cta"
                >
                  <span>{{ cardContent.cardButtonPrimaryText }}</span>
                </generic-link>
              </template>
              <template v-if="cardContent.cardButtonSecondaryUrl && cardContent.cardButtonSecondaryText">
                <generic-link
                  :target="secondaryButtonTarget"
                  :href="cardContent.cardButtonSecondaryUrl"
                  class="btn btn-secondary-cta"
                >
                  <span>{{ cardContent.cardButtonSecondaryText }}</span>
                </generic-link>
              </template>
            </div>
          </template>
          <template v-else-if="cardContent.cardButtonPrimaryUrl">
            <generic-link
              :target="primaryButtonTarget"
              :href="cardContent.cardButtonPrimaryUrl"
              class="card-overlay-link"
            />
          </template>
        </div>
      </div>
    </template>

    <!-- Icon Card -->
    <template v-if="cardContent.cardType === 'icon'">

      <div
        :style="`background-color: ${cardContent.cardBackgroundColor.rgbaString}`"
        :class="[`col-item card card-${cardContent.cardType} card-text-${cardContent.cardTextAlign}`, {'card-text-center': cardContent.cardIconPosition === 'center' }, {'card-text-contained': cardContent.cardIconPosition === 'leftcontent' }]"
      >
        <div class="card-content-body">
          <template v-if="cardContent.cardIconPosition === 'left'">
            <div class="icon-header">
              <div class="icon-container">
                <!--<img-->
                  <!--:src="backgroundImageUrl"-->
                  <!--:class="{'drop-shadow': cardContent.cardIconDropShadow === true }"-->
                  <!--class="svg-icon"-->
                  <!--alt="Icon"-->
                <!--&gt;-->
                  <AImage
                    :img="cardContent.fileStore"
                    :title="cardContent.cardTitle"
                    :alt="cardContent.cardTitle"
                    :preset="`grid-image-${gridSize}`"
                    :class="{'drop-shadow': cardContent.cardIconDropShadow === true }"
                    class="svg-icon"
                    responsive
                  />
              </div>
              <div class="title">
                <h3 :style="`color: ${cardContent.cardTextColor.rgbaString}`">{{ cardContent.cardTitle }}</h3>
              </div>
            </div>
            <div
            v-if="cardContent.cardDescription"
            :style="`color: ${cardContent.cardTextColor.rgbaString}`"
            class="description"
          >
            {{ cardContent.cardDescription }}
          </div>
          </template>
          <template v-if="cardContent.cardIconPosition === 'leftcontent'">
              <div class="icon-container">
                <img
                  :src="backgroundImageUrl"
                  :class="{'drop-shadow': cardContent.cardIconDropShadow === true }"
                  class="svg-icon"
                  alt="Icon"
                >
              </div>
              <div class="icon-content">
                <div class="title">
                  <h3 :style="`color: ${cardContent.cardTextColor.rgbaString}`">{{ cardContent.cardTitle }}</h3>
                </div>
                <div
                v-if="cardContent.cardDescription"
                :style="`color: ${cardContent.cardTextColor.rgbaString}`"
                class="description"
              >
                {{ cardContent.cardDescription }}
              </div>
            </div>
          </template>
          <template v-if="cardContent.cardIconPosition === 'center'">
            <div class="icon-container text-center">
              <img
                :src="backgroundImageUrl"
                :class="{ 'drop-shadow': cardContent.cardIconDropShadow === true }"
                class="svg-icon"
                alt="Icon"
              >
            </div>
            <div class="title">
              <h3 :style="`color: ${cardContent.cardTextColor.rgbaString}`">
                {{ cardContent.cardTitle }}
              </h3>
            </div>
            <div
              v-if="cardContent.cardDescription"
              :style="`color: ${cardContent.cardTextColor.rgbaString}`"
              class="description"
            >
              {{ cardContent.cardDescription }}
            </div>
          </template>
        </div>
        <template
          v-if="cardContent.cardButtonPrimaryUrl && cardContent.cardButtonPrimaryText || cardContent.cardButtonSecondaryUrl && cardContent.cardButtonSecondaryText"
        >
          <div class="card-content-footer">
            <div
              v-if="cardContent.cardButtonPrimaryUrl && cardContent.cardButtonPrimaryText || cardContent.cardButtonSecondaryUrl && cardContent.cardButtonSecondaryText"
              class="card-actions"
            >
              <template v-if="cardContent.cardButtonPrimaryUrl && cardContent.cardButtonPrimaryText">
                <generic-link
                  :target="primaryButtonTarget"
                  :href="cardContent.cardButtonPrimaryUrl"
                  class="btn btn-primary-cta"
                >
                  <span>{{ cardContent.cardButtonPrimaryText }}</span>
                </generic-link>
              </template>
              <template v-if="cardContent.cardButtonSecondaryUrl && cardContent.cardButtonSecondaryText">
                <generic-link
                  :target="secondaryButtonTarget"
                  :href="cardContent.cardButtonSecondaryUrl"
                  class="btn btn-secondary-cta"
                >
                  <span>{{ cardContent.cardButtonSecondaryText }}</span>
                </generic-link>
              </template>
            </div>
          </div>
        </template>
        <template v-else-if="cardContent.cardButtonPrimaryUrl">
          <generic-link
            :target="primaryButtonTarget"
            :href="cardContent.cardButtonPrimaryUrl"
            class="card-overlay-link"
          />
        </template>
      </div>
    </template>

    <!-- Video Card -->
    <template v-if="cardContent.cardType === 'video'">
      <div
        :class="[`col-item card card-${cardContent.cardType}`]"
      >
        <iframe
          :src="`${cardContent.cardVideoUrl}?rel=0&amp;controls=0&amp;showinfo=0`"
          width="100%"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
        />
      </div>
    </template>

    <!-- Wysiwyg Card -->
    <template v-if="cardContent.cardType === 'wysiwyg'">
      <div
        :class="[`col-item card card-${cardContent.cardType}`]"
      >
        <div v-html="sanitizedContent" />
      </div>
    </template>

  </div>
</template>
<script>
import GenericLink from '../../ui-elements/generic-link'
// import FilestorePresignedURL from '../../filestore-presigned-url'

export default {
  components: {
    GenericLink
  },
  // mixins: [
  //   FilestorePresignedURL
  // ],
  // data() {
  //   return {
  //     backgroundImageUrl: ''
  //   }
  // },
  props: {
    'cardContent': {
      type: Object,
      default: () => {}
    },
    filestore: {
      type: [Object, String],
      required: true
    },
    gridSize: {
      type: String,
      required: true
    }
  },
  watch: {
    cardContent: {
      handler: function() {
        if (this.cardContent.cardBackgroundUrl) {
          // this.updateFilestoreImagePaths()
        }
      },
      deep: true
    }
  },
  computed: {
    sanitizedContent() {
      // This removes the target attribute from the Quill-generated links
      const content = this.cardContent.cardDescription
      return content.replace(/target="_blank"/g, '')
    },
    primaryButtonTarget() {
      if (this.cardContent.cardButtonPrimaryTargetBlank != null &&
        this.cardContent.cardButtonPrimaryTargetBlank) {
        return '_blank'
      } else {
        return '_self'
      }
    },
    secondaryButtonTarget() {
      if (this.cardContent.cardButtonSecondaryTargetBlank != null &&
        this.cardContent.cardButtonSecondaryTargetBlank) {
        return '_blank'
      } else {
        return '_self'
      }
    },
    backgroundImageUrl: function() {
      if ( this.cardContent.opmode === 'filestore' ) {
        return this.$store.getters['filestore/fileCachedImageURL']({
          filepath: this.cardContent.fileStore.filepath,
          preset: this.cardContent.fileStore.preset,
          filestorename: this.filestore.name
        })
      }
      return this.cardContent.cardBackgroundUrl
    }

  },
  methods: {
    removeItem: function(item) {
      this.$parent.removeItem(item)
    },
    // updateFilestoreImagePaths() {
    //   this.getPreSignedURL(this.cardContent)
    //     .then(data => {
    //       this.$set(this, 'backgroundImageUrl', data)
    //     })
    // }
  },
  created() {
  //  this.updateFilestoreImagePaths()
    if ( this.cardContent.opmode === 'filestore' ) {
      this.cardContent.fileStore.filestorename = this.filestore.name
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

$card-photo-primary-button-color:$primary;
$card-photo-secondary-button-color:$secondary;
$card-padding:2em;
$card-border-color:$border-color;

.card {
  @if $enable-rounded {
    border-radius: $border-radius-sm;
  }
}

@mixin transform-scale($x:1, $y:1){
    -webkit-transform: scale($x, $y);
    -moz-transform   : scale($x, $y);
    -o-transform     : scale($x, $y);
    -ms-transform    : scale($x, $y);
    transform        : scale($x, $y);
}
//card icon --------------------------------------
//card photo --------------------------------------
///image overlay stuff

.effect-image-scale{
 ::v-deep .card-image {
    @include transform-scale (1.02, 1.02);
    @include transition (transform .6s);
  }

  @include hover-focus {
   ::v-deep .card-image {
      @include transform-scale (1.1, 1.1);
    }
  }
}
.image-background {
  height: 100%;
  width: 100%;
  position: absolute;
  background-size: cover;
  background-position: 50% 20%;
}
.image-overlay {
  background: $black;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  @include transition (opacity .4s);
}

.card-photo {
  .card-image {
    height: 100%;
  }
  .card-content {
    position: absolute;
    width: 100%;
  }
  @include hover-focus {
    .image-overlay {
      opacity: .5 !important;
    }
  }
}

.card-photo, .card-color {
  min-height: 220px;
  .card-actions {
    margin-top: 1em;
  }
  .description {
    font-size: 1.1em;
  }
}
.card-photo {
  background-color: $dark;
  color: $white;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
  //height: 100%;
  width:100%;
  box-shadow: none;
  border-radius: 0px;
  border: 0px;
  overflow: hidden;
  margin-bottom:2em;
}
//card video

.card-video {
  iframe {
    height:100%;
  }
}
//card content common --------------------------------
.card {
  //define the generic tansform speed
  .card-content {
    @include transition (transform .6s); //set transform back to base
    transform: translate(0, 0em);
  }
  &:hover {
    //define hover state for each position
    .card-content-position-top {
      transform: translate(0, 1em)
    }
    .card-content-position-bottom {
      transform: translate(0, -1em)
    }
    .card-content-position-center,
    .card-content-positoin-centered {
      transform: translate(0, -1em)
    }
  }
}

//cta btn actions
.card-actions {
  a.btn {
    padding: 1em 1.5em;
    &.btn-primary-cta {
      //color: $white;
      color:var(--main-button-primary-text-color);
      background-color:var(--main-button-primary-background-color);
      @include transition(background-color .3s);
      @include hover-focus {
      background-color:var(--main-button-primary-highlight-background-color);
      //background-color: lighten($primary, 10%);
      }
    }
    &.btn-secondary-cta {
      color:var(--main-button-secondary-text-color);
      background-color:var(--main-button-secondary-background-color);
      @include transition(background-color .3s);
      @include hover-focus {
      color:var(--main-button-secondary-highlight-text-color);
      background:var(--main-button-secondary-highlight-background-color);

        //background-color: lighten($secondary, 10%);
      }
    }
  }
}

//card content text
.card-content-body {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100%;
  z-index: 1;
  padding: 1.5em;
  font-size: .9em;
  @include media-breakpoint-up(lg) {
    font-size: 1em;
  }
}

//card content foooter
.card-content-footer {
  padding: 0em 1.5em 1.5em 1.5em;
}

.card-text-left {
  text-align: left;
}

.card-text-center {
  text-align: center;
}

.card-text-right {
  text-align: right;
}

@include media-breakpoint-up(lg) {
  .card-text-center {
    .card-content-body {
      padding: 1.5em 15%;
    }
  }
  .car-text-left {
    .card-content-body {
      padding-right: 20%;
    }
  }
  .card-text-right {
    .card-content-body {
      padding-left: 20%;
    }
  }
  .car-text-left {
    .card-content-body {
      padding-right: 20%;
    }
  }
  .card-text-right {
    .card-content-body {
      padding-left: 20%;
    }
  }
}

//card content position
.card-content-position-centered,
.card-content-position-center {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

//card content position
.card-content-position-centered,
.card-content-position-center {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.card-content-position-top {
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.card-content-position-bottom {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

//card action position
.card-text-center {
  .card-actions {
    .btn {
      &:not(:last-child){
        margin-right:1em;
      }
    }
  }
}

.card-text-left {
  .card-actions {
    .btn {
      margin-right: 1em;
    }
  }
}

.card-text-right {
  .card-actions {
    .btn {
      margin-left: 1em;
    }
  }
}

//we target only card icon
.card-color {
  .card-actions {
  .btn.btn-primary-cta {
  background-color: rgba($black, .4);
  &:hover {
  background-color: rgba($black, .75);
  }
  }
  .btn.btn-secondary-cta {
  background-color: rgba($black, .2);
  &:hover {
  background-color: rgba($black, .5);
  }
  }
  }
}

//we target only card icon
.card-icon {
  min-height: 200px;
  .icon-header {
    display: flex;
    margin-bottom: 1em;
    align-items: center;
    h3 {
      margin: 0em;
    }
    .icon-container {
      margin-right: 1em;
        width: 8em;
        height: 8em;
      img {
        width: 4em;
        height: 4em;
      }
    }
  }
  &.card-text-center {
    .icon-container {
      margin: 0em auto;
      margin-bottom: 1em;
    }
  }
  .icon-container {
    img {
      width: 7em;
      height: 7em;
    }
  }
  .btn.btn-primary-cta {
    background-color: rgba($black, .5);
  }
  img {
    &.drop-shadow {
      filter: drop-shadow(4px 4px 0 rgba(0, 0, 0, 0.3));
    }
  }

  &.card-text-contained {
    .icon-container{
      margin-right:1rem;
    }
    .card-content-body {
      display:flex;
      flex-direction: row;
      align-items: flex-start;
    }
    .icon-content {
      height:100%;
      word-break: break-word;
      display:flex;
      flex-direction: column;
    }
  }
}

.card-icon {
  &.card-icon-border {
    border: 2px solid;
    border-color: $card-border-color;
  }
}

//when this is the only link on the card we need to provide a focus state
.card-overlay-link {
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-indent: -99em;
  white-space: nowrap;
  overflow: hidden;
  z-index: 2; //animate box shadow via opacity
  &:after {
    content: '';
    left: 0;
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    box-shadow: inset 1px 1px 20px 1px rgba($black, .5);
    opacity: 0;
    @include transition (opacity .3s);
  }
  &:focus {
    &:after {
      opacity: 1;
    }
  }
}

//quill
::v-deep  .card-wysiwyg {
  padding:1.5rem;
//alignment
  .ql-align-right {
    text-align: right;
  }
  .ql-align-center {
    text-align: center;
  }
  .ql-align-justify {
    text-align: justify;
  }
//code
  pre {
    color: inherit;
  }
//base typography spacing
  ol,
  ul {
    padding-left: 1.5rem;
    margin-bottom: 1rem;
  }
  ul {
    list-style: disc;
    list-style-position: outside;
  }
  //blockquote
  .ql-indent-1{
    margin-left:1rem;
  }
    .ql-indent-2{
    margin-left:2rem;
  }
    .ql-indent-3{
    margin-left:3rem;
  }
    .ql-indent-4{
    margin-left:4rem;
  }
    .ql-indent-5{
    margin-left:5rem;
  }  .ql-indent-6{
    margin-left:6rem;
  }
    .ql-indent-7{
    margin-left:7rem;
  }
    .ql-indent-8{
    margin-left:8rem;
  }


  blockquote {
    border-left: 2px solid;
    border-color:var(--main-border-color);
    border-color: inherit;
    padding-left: 1.5rem;
    font-style: italic;
  }
}

</style>
